module.exports = __webpack_public_path__ + "assets/108b53201dab0af6a61fd4b0f81c3558.png";